import React, { createContext, FC, PropsWithChildren } from 'react'

const ModalContext = createContext<Record<string, never>>({})

const ModalProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ModalContext.Provider value={{}}>
      <div id="modalContainer" />
      {children}
    </ModalContext.Provider>
  )
}

export { ModalContext }
export default ModalProvider
